import i18n from "i18next";
import * as React from "react";
import { BaseAPI, Configuration } from "../api";

import { useAuth } from "../contexts";
import { useLanguages } from "./applicationHooks";

export let baseUrl =
  (document.getElementById("_baseUrl") as HTMLInputElement)?.value || "~";
console.log("Base url is " + baseUrl);

if (baseUrl === "~") {
  const hostUrl = window.location.href.split("/");
  baseUrl = hostUrl[0] + "//" + hostUrl[2];
}
console.log("lang", i18n.language);
export function useApiService<T extends BaseAPI>(
  type: new (configuration: Configuration) => T,
  transformRequest?: (request: RequestInit) => RequestInit
): T {
  const { logout, getAccessToken } = useAuth();

  const configuration = React.useMemo(() => {
    const cfg: Configuration = {
      apiKeyPromise: getAccessToken,
      basePath: baseUrl,
      headers: {
        "accept-language": i18n.language,
      },
      middlewares: [
        {
          pre(request) {
            request.credentials = "include";
            const result = transformRequest
              ? transformRequest(request)
              : request;
            return Promise.resolve(result);
          },
          post(response) {
            if (response.status === 401 || response.status === 403) {
              logout();
            }
            return Promise.resolve(response);
          },
        },
      ],
    };

    return cfg;
  }, [getAccessToken, transformRequest, logout]);
  return React.useMemo(() => new type(configuration), [configuration, type]);
}
